import React from "react";
import DocumentationIcon from "../../../assets/icons/Documentation.svg";
import SystemStatusIcon from "../../../assets/icons/SystemStatus.svg";
import ContactSupportIcon from "../../../assets/icons/ContactSupport.svg";
import { Link } from "react-router-dom";

const GridData = [
  {
    icon: DocumentationIcon,
    title: "View Documentation",
    description: "Browse our comprehensive guides and tutorials",
    link: "/support/documentation",
  },
  {
    icon: SystemStatusIcon,
    title: "System Status",
    description: "Check current system status and uptime",
    link: "/support/system-status",
  },
  {
    icon: ContactSupportIcon,
    title: "FAQ's",
    description: "Find answers to common questions",
    link: "/support/faqs",
  },
];

const SupportGrid = () => {
  return (
    <div className="w-full grid sm:grid-cols-3 gap-4 lg:gap-6">
      {GridData.map((item, index) => (
        <Link to={item.link} key={index}>
          <div className="flex flex-col justify-start px-5 lg:px-7 py-7 sm:py-9 border border-line rounded-[10px] bg-white h-full">
            <div className="max-w-[260px]">
              <div className="w-10 sm:w-12 h-10 sm:h-12 rounded-full flex items-center justify-center border border-primary bg-primary/10 mb-2">
                <img
                  src={item.icon}
                  alt={item.title}
                  className="text-4xl w-5 sm:w-auto "
                />
              </div>
              <h2 className="text-lg md:text-xl lg:text-2xl font-semibold text-content">
                {item.title}
              </h2>
              <p className="text-sm text-content">{item.description}</p>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default SupportGrid;
